import { httpRequest } from '@/apis/request'
import { response } from '@/apis/types'

enum Apis {
  getEzSortToken = 'ezsort/auth',
  getEzSortDownloadUrl = 'ezsort/versions/latest',
}

// 获取彩标token
export const fetchEzSortToken = () => {
  return httpRequest.get<response<{ token: string }>>(Apis.getEzSortToken)
}
/** 获取彩标下载链接 */
export const fetchEzSortDownloadUrl = () => {
  return httpRequest.get(Apis.getEzSortDownloadUrl)
}
